<template>
  <div class="bg-white flex mdmax:flex-col">
    <div class="p-6 flex-1 shadow-border-r mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full">
      <p class="font-bold text-lg mb-6">Kategori Barang</p>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">ID</label>
        <p class="text-neutral-500">{{ goodsCategoryDetail.code }}</p>
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Kategori</label>
        <p class="text-neutral-500">{{ goodsCategoryDetail.name }}</p>
      </div>
      <div class="">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Deskripsi</label>
        <p class="text-neutral-500">{{ goodsCategoryDetail.category_description || '-' }}</p>
      </div>
    </div>
    <div class="p-6 flex-1 mdmax:flex-auto mdmax:w-full">
      <p class="font-bold text-lg mb-6">Sub Kategori</p>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Terdapat Sub Kategori</label>
        <p class="text-neutral-500">{{ goodsCategoryDetail.sub_category_code ? 'Ya' : 'Tidak' }}</p>
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Sub Kategori</label>
        <p class="text-neutral-500">{{ goodsCategoryDetail.sub_category_name || '-' }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('master', ['goodsCategoryDetail']),
    goodCategoryCode() {
      return this.$route.params.id
    }
  },
  created() {
    this.getGoodCategoryInfo()
  },
  methods: {
    ...mapActions('master', ['getGoodsCategoryDetail']),
    getGoodCategoryInfo() {
      this.getGoodsCategoryDetail({
        code: this.goodCategoryCode
      })
    }
  }
}
</script>
